import './ArticleSelector.scss';
import article from '../../model/article';
import makes from '../../model/makes';
import Article from './Article';
import React from 'react';
import _ from 'lodash';
import cookie from 'js-cookie';

const createDefaultSearcher = ({
  contentType
}) => {
  return ({
    query,
    filter,
    offset,
    limit
  }) => {
    return article.search({
      query: query,
      filter: filter,
      offset: offset,
      limit: limit,
      contentType: contentType
    });
  };
};

class ArticleSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      searching: false,
      makes: null,
      result: null,
      filter: null
    };

    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.handleQueryChange = this.handleQueryChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  printMakes(makes) {
    let makesString = '';
    if (makes) {
      makesString += makes.map((make) => {
        return make.name;
      });
    }
    return makesString;
  }

  printFilterButton() {
    let selected = null;

    if (this.state.filter) {
      _.forEach(this.state.makes, (make) => {
        if (make.id === this.state.filter) {
          selected = make.name;
        }
      });
    }

    return (
      <div className="btn-group" role="group">
        <div className="dropdown">
          <button
            type="button"
            data-toggle="dropdown"
            className="btn btn-default dropdown-toggle"
            disabled={this.state.searching}
          >
            Merke: <strong>{selected || 'Alle'}</strong> <span className="caret"></span>
          </button>
          <ul className="dropdown-menu" >
            <li className={this.state.filter === null ? 'active' : ''}>
              <a href="#" onClick={(e) => {
                e.preventDefault();
                this.handleFilterChange(null);
              }}>
                Alle
              </a>
            </li>
            <li role="separator" className="divider"></li>
            {this.state.makes.map((make, i) => {
              return (
                <li key={`make-${i}`} className={this.state.filter === make.id ? 'active' : ''}>
                  <a href="#" onClick={(e) => {
                    e.preventDefault();
                    this.handleFilterChange(make.id);
                  }}>
                    {make.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }

  handleLoadMore() {
    this.setState({
      searching: true
    });

    const filter = this.state.filter;
    const query = this.state.query;
    const previous = this.state.result.items;
    const offset = previous.length;

    const searcher = this.props.searcher || createDefaultSearcher({
      contentType: this.props.contentType
    });

    searcher({
      query: query,
      offset: offset,
      filter: filter,
      limit: this.props.pageSize
    }).then((result) => {
      this.setState({
        searching: false,
        result: {
          query: query,
          total: result.total,
          offset: result.offset,
          items: previous.concat(result.items)
        }
      });
    });
  }

  componentDidMount() {
    const filter = cookie.get('mgMakeFilter');

    if (filter !== 'null') { // null is string in this case
      this.setState({
        filter: filter
      });
    }

    makes.all().then((makes) => {
      this.setState({
        makes: makes
      });
    });
    if (this.props.searchOnOpen) {
      this.handleSearch();
    }
  }

  setTabCookie(makeId) {
    const tabLink = makeId;
    const cookieName = 'mgMakeFilter';

    cookie.set(cookieName, tabLink, {path: '/'});
  }

  handleFilterChange(makeId) {
    this.setState({
      filter: makeId
    });
    this.setTabCookie(makeId);
  }

  handleQueryChange(e) {
    this.setState({
      query: e.target.value
    });
  }

  handleSearch(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({
      searching: true
    });

    const filter = this.state.filter;
    const query = this.state.query;
    const searcher = this.props.searcher || createDefaultSearcher({
      contentType: this.props.contentType
    });

    searcher({
      query: query,
      filter: filter,
      limit: this.props.pageSize
    }).then((result) => {
      this.setState({
        searching: false,
        result: {
          limit: this.props.pageSize,
          query: query,
          total: result.total,
          offset: result.offset,
          items: result.items
        }
      });
    });
  }

  render() {
    return (
      <section className="contentful-entity-selector">
        <form onSubmit={this.handleSearch}>
          <div className="form-group has-feedback">
            <div className="contentful-entity-form-group">
              <div className="col-md-9 search-row">
                <input
                  type="text"
                  placeholder="Søk..."
                  className="form-control"
                  value={this.state.query}
                  onChange={this.handleQueryChange}
                  disabled={this.state.searching}
                  autoFocus={true}
                />

                <span className="form-control-feedback" aria-hidden="true">
                  {this.state.searching &&
                    <i className="fa fa-spinner fa-pulse fa-fw"></i>
                  }
                  {!this.state.searching &&
                    <i className="fa fa-search"></i>
                  }
                </span>
              </div>
              <div className="col-md-3">
                {this.state.makes && this.printFilterButton()}
              </div>
            </div>
            {Boolean(this.state.result) && !this.state.result.items.length &&
              <h2 className="h3 contentful-entity-result-text">Ingen treff på &laquo;{this.state.result.query}&raquo;</h2>
            }
            {Boolean(this.state.result) && Boolean(this.state.result.items.length) &&
              <h2 className="h3 contentful-entity-result-text">{this.state.result.total} treff på &laquo;{this.state.result.query}&raquo;</h2>
            }
            <ul className="contentful-entity-list list-unstyled">
              {Boolean(this.state.result) && this.state.result.items.map((article) => {
                return (
                  <li key={article.id} className="contentful-entity-list-item">
                    <Article
                      article={article}
                      //disabled={this.props.disabled}
                      onSelect={this.props.onSelect}
                      aspect={1}
                      showIcon={false}
                      allowEdit={false}
                    />
                  </li>
                );
              })}
            </ul>
            {Boolean(this.state.result) && this.state.result.total > this.state.result.items.length &&
              <p className="text-center">
                <a
                  className={`${this.state.searching ? 'disabled ' : ''}btn btn-default`}
                  onClick={this.handleLoadMore}
                >
                  {this.state.searching &&
                    <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Laster...</span>
                  }
                  {!this.state.searching &&
                    <span>Last flere treff <span className="badge">{this.state.result.total - this.state.result.items.length}</span></span>
                  }
                </a>
              </p>
            }
          </div>
        </form>
      </section>
    );
  }
}

ArticleSelector.defaultProps = {
  pageSize: 12,
  searcher: null
};

export default ArticleSelector;
